module.exports = __webpack_public_path__ + "img/binding.6dff39c5.png";